<template>
  <section v-if="events.length" class="container z-grid v-page-section-container-padding">
    <div class="col-span-full 2xl:col-span-10 2xl:col-start-2">
      <AtomHeadingPageSectionLanding class="mb-5">{{ $t('home-events-title') }}</AtomHeadingPageSectionLanding>
      <ul class="grid grid-cols-12 gap-y-4 sm:gap-5 lg:gap-8">
        <li v-for="(event, index) in events" :key="index" class="col-span-full sm:col-span-6 lg:col-span-4" :class="{ 'hidden sm:flex lg:hidden': index >= 3, flex: index < 3 }">
          <MoleculeCardEventCompact
            :url="event.url"
            :when="event.eventDate ? new Date(event.eventDate) : undefined"
            :title="event.production.title"
            :image="event.production.teaserImage"
            :works="event.production.works"
          />
        </li>
        <li class="col-span-full sm:col-span-6 lg:col-span-4">
          <MoleculeButton :url="buttonUrl" size="x-large" class="hidden lg:flex w-full" background-color="bg-app-primary-1-red--fire-brick hover:bg-black">
            {{ $t('home-events-button-label') }}
          </MoleculeButton>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps({
  events: { type: Array as PropType<any[]>, required: true },
  // Optional: the overview url comes from the global store, which is still empty on the first render.
  buttonUrl: { type: String, required: false, default: undefined },
})
</script>
